import React from 'react';
import { Typography, Divider, Space, Image, Alert } from 'antd';
import { EditOutlined, FormOutlined, UserOutlined, InfoCircleOutlined } from '@ant-design/icons';

const { Title, Paragraph, Text } = Typography;

const HelpMokykluRedagavimas = () => (
    <div className="help-content">
        <Space direction="vertical" size="middle" style={{ width: '100%' }}>
            <div>
                <Title level={2} style={{ marginBottom: 16 }}>
                    Mokyklos informacijos redagavimas
                </Title>
                <Paragraph style={{ fontSize: 16, lineHeight: 1.8 }}>
                    Šiame skyriuje aprašytas mokyklos informacijos redagavimo procesas, kuris apima pagrindinės informacijos ir kontaktų valdymą.
                </Paragraph>
            </div>

            <Alert
                message="Kaip pasiekti redagavimo langą"
                description={(
                    <Paragraph style={{ marginBottom: 0, fontSize: 15 }}>
                        Redagavimo langą galite pasiekti iš <Text strong>&ldquo;Mokyklos pagrindinė informacija&rdquo;</Text> puslapio, spustelėję mygtuką <Text strong>&ldquo;Redaguoti mokyklos informaciją&rdquo;</Text> su pieštuko ikona.
                    </Paragraph>
                )}
                type="info"
                icon={<InfoCircleOutlined />}
                showIcon
                style={{ marginBottom: 16 }} />

            <Divider />

            <div>
                <Title level={3} style={{ marginBottom: 12 }}>
                    <EditOutlined style={{ marginRight: 8, color: '#fdab01' }} />
                    Pagrindinės informacijos redagavimas
                </Title>
                <Paragraph style={{ fontSize: 15, lineHeight: 1.8, marginBottom: 16 }}>
                    Redagavimo lange matote du pagrindinius tab&apos;us: <Text strong>&ldquo;Pagrindinis&rdquo;</Text> ir <Text strong>&ldquo;Kontaktai&rdquo;</Text>. <Text strong>&ldquo;Pagrindinis&rdquo;</Text> tab&apos;e galite redaguoti:
                </Paragraph>

                <div className="help-screenshot-placeholder" style={{ marginBottom: 16 }}>
                    <Image
                        src="https://api.vksis.lt/img/help/mokyklos_redagavimas_1.webp"
                        alt="Mokyklos redagavimo lango screenshot"
                        preview={false}
                        style={{ width: '100%', borderRadius: 8, border: '1px solid #e8e8e8' }} />
                </div>

                <ul style={{ fontSize: 15, lineHeight: 1.8, marginTop: 12, marginBottom: 16 }}>
                    <li><Text strong>Pavadinimas</Text> – mokyklos pilnas pavadinimas (privalomas laukas)</li>
                    <li><Text strong>Mokyklos tipas</Text> – pasirinkite iš išplečiamojo sąrašo (pvz., Gimnazija, Progimnazija) (privalomas laukas)</li>
                    <li><Text strong>Adresas</Text> – pilnas mokyklos adresas su pašto kodu (privalomas laukas)</li>
                    <li><Text strong>Koordinatės</Text> – platuma (latitude) ir ilguma (longitude) (privalomi laukai)</li>
                    <li><Text strong>Telefono numeris</Text> – kontaktinis telefono numeris</li>
                    <li><Text strong>El. paštas</Text> – mokyklos el. pašto adresas</li>
                    <li><Text strong>Svetainė</Text> – mokyklos interneto svetainės adresas</li>
                    <li><Text strong>Aprašymas</Text> – papildomas mokyklos aprašymas</li>
                </ul>

                <Paragraph style={{ fontSize: 15, lineHeight: 1.8, marginBottom: 16 }}>
                    <Text strong>Dešinėje pusėje</Text>
                    {' '}matote integruotą Google Maps žemėlapį, kuriame mokyklos vieta rodoma pagal įvestas{' '}
                    <Text strong>koordinates</Text> (platuma ir ilguma). Žemėlapyje galite perjungti tarp{' '}
                    <Text strong>&ldquo;Map&rdquo;</Text> ir <Text strong>&ldquo;Satellite&rdquo;</Text> vaizdo. Geltona-oranžinė
                    žymė rodo mokyklos vietą žemėlapyje.
                </Paragraph>

                <Paragraph style={{ fontSize: 15, lineHeight: 1.8, marginBottom: 16 }}>
                    Užpildę visus privalomus laukus, spauskite mygtuką <Text strong>&ldquo;Atnaujinti mokyklą&rdquo;</Text> apačioje, kad išsaugotumėte pakeitimus.
                </Paragraph>
            </div>

            <Divider />

            <div>
                <Title level={3} style={{ marginBottom: 12 }}>
                    <UserOutlined style={{ marginRight: 8, color: '#fdab01' }} />
                    Mokyklos kontaktų valdymas
                </Title>
                <Paragraph style={{ fontSize: 15, lineHeight: 1.8, marginBottom: 16 }}>
                    Perjungę į <Text strong>&ldquo;Kontaktai&rdquo;</Text> tab&apos;ą, matote mokyklos kontaktų valdymo langą.
                </Paragraph>

                <div className="help-screenshot-placeholder" style={{ marginBottom: 16 }}>
                    <Image
                        src="https://api.vksis.lt/img/help/mokyklos_redagavimas_2.webp"
                        alt="Mokyklos kontaktų valdymo lango screenshot"
                        preview={false}
                        style={{ width: '100%', borderRadius: 8, border: '1px solid #e8e8e8' }} />
                </div>

                <Alert
                    message="Svarbu"
                    description={(
                        <Paragraph style={{ marginBottom: 0, fontSize: 14 }}>
                            Mokyklos kontaktai nėra sistemos vartotojai – jie neturi prisijungimo prie sistemos. Kontaktai naudojami tik informaciniais tikslais norint gauti informaciją, susijusią su mokykla.
                        </Paragraph>
                    )}
                    type="info"
                    icon={<InfoCircleOutlined />}
                    showIcon
                    style={{ marginBottom: 16 }} />

                <Paragraph style={{ fontSize: 15, lineHeight: 1.8, marginBottom: 16 }}>
                    Kontaktų lange matote:
                </Paragraph>
                <ul style={{ fontSize: 15, lineHeight: 1.8, marginTop: 12, marginBottom: 16 }}>
                    <li><Text strong>Kontaktų lentelę</Text> su stulpeliais: Vardas pavardė, Pareigos, El. paštas, Telefonas, Aprašymas, Veiksmai</li>
                    <li><Text strong>&ldquo;Atnaujinti&rdquo;</Text> mygtuką su apskrito rodyklės ikona – atnaujina kontaktų sąrašą</li>
                    <li><Text strong>&ldquo;Pridėti kontaktą&rdquo;</Text> mygtuką su pliuso ikona – atidaro naujo kontakto pridėjimo formą</li>
                </ul>

                <Paragraph style={{ fontSize: 15, lineHeight: 1.8, marginBottom: 16 }}>
                    Kiekvieno kontakto eilutėje matote <Text strong>&ldquo;Redaguoti&rdquo;</Text> mygtuką su pieštuko ikona, kuris leidžia redaguoti konkretaus kontakto informaciją.
                </Paragraph>
            </div>

            <Divider />

            <div>
                <Title level={3} style={{ marginBottom: 12 }}>
                    <FormOutlined style={{ marginRight: 8, color: '#fdab01' }} />
                    Naujo kontakto pridėjimas
                </Title>
                <Paragraph style={{ fontSize: 15, lineHeight: 1.8, marginBottom: 16 }}>
                    Spustelėję <Text strong>&ldquo;Pridėti kontaktą&rdquo;</Text> mygtuką, atsidaro modalus langas naujo kontakto pridėjimui.
                </Paragraph>

                <div className="help-screenshot-placeholder" style={{ marginBottom: 16 }}>
                    <Image
                        src="https://api.vksis.lt/img/help/mokyklos_redagavimas_3.webp"
                        alt="Kontakto pridėjimo modalo screenshot"
                        preview={false}
                        style={{ width: '100%', borderRadius: 8, border: '1px solid #e8e8e8' }} />
                </div>

                <Paragraph style={{ fontSize: 15, lineHeight: 1.8, marginBottom: 16 }}>
                    Atsidariusiame redagavimo lange užpildykite šiuos laukus:
                </Paragraph>
                <ul style={{ fontSize: 15, lineHeight: 1.8, marginTop: 12, marginBottom: 16 }}>
                    <li><Text strong>Vardas pavardė</Text> – kontaktinio asmens vardas ir pavardė (privalomas laukas, pažymėtas žvaigždute)</li>
                    <li><Text strong>Pareigos</Text> – pasirinkite iš išplečiamojo sąrašo (pvz., Direktoriaus pavaduotojas) (privalomas laukas)</li>
                    <li><Text strong>El. paštas</Text> – kontaktinio asmens el. pašto adresas (privalomas laukas)</li>
                    <li><Text strong>Telefonas</Text> – kontaktinio telefono numeris (privalomas laukas)</li>
                    <li><Text strong>Aprašymas</Text> – papildomas aprašymas (neprivalomas laukas, maksimalus simbolių skaičius – 1000)</li>
                </ul>

                <Paragraph style={{ fontSize: 15, lineHeight: 1.8, marginBottom: 16 }}>
                    Užpildę formą, spauskite <Text strong>&ldquo;Pridėti&rdquo;</Text> mygtuką, kad išsaugotumėte kontaktą. Jei norite atšaukti, spauskite <Text strong>&ldquo;Atšaukti&rdquo;</Text> mygtuką.
                </Paragraph>
            </div>
        </Space>
    </div>
);

export default HelpMokykluRedagavimas;
